import * as WebSocketRequest from './ws-requests'

const bind = function () {
    const $deliveryAndFvForm = $('#deliveryAndFvForm');
    $deliveryAndFvForm.find('input').on('focusout', function (e) {
        if ($(this).attr('type') === 'checkbox' && !$(this).prop('checked')) {
            WebSocketRequest.customWebSocketAction({[$(this).attr('name')]: 0}, $deliveryAndFvForm.data('ws'));
        } else {
            WebSocketRequest.customWebSocketAction({[$(this).attr('name')]: $(this).val()}, $deliveryAndFvForm.data('ws'));
        }
    });
    $deliveryAndFvForm.find('select').on('changed.bs.select', function (e) {
        WebSocketRequest.customWebSocketAction({[$(e.currentTarget).attr('name')]: $(e.currentTarget).val()}, $deliveryAndFvForm.data('ws'));
    });
    $deliveryAndFvForm.find('[type=radio]').on('change', function (e) {
        if ($(this).prop('checked')) {
            WebSocketRequest.customWebSocketAction({[$(this).attr('name')]: $(this).val()}, $deliveryAndFvForm.data('ws'));
        }
    });
};

export {
    bind,
}